import { api } from '../_generated/api/sdai-api.generated';

export const sdaiApi = api.enhanceEndpoints({
  addTagTypes: ['Explanation', 'Chat', 'Analysis'],
  endpoints: {
    ReadExplanation: {
      providesTags: (_, __, arg) => [
        { type: 'Explanation' as const, id: arg.explanationId },
      ],
    },
    ReadFileExplanation: {
      providesTags: (_, __, arg) => [
        { type: 'Explanation' as const, id: arg.explanationId },
      ],
    },
    CreateExplanation: {
      invalidatesTags: (result) => [
        {
          type: 'Explanation' as const,
          id: result?.createExplanation.explanationId,
        },
      ],
    },
    CreateFileExplanation: {
      invalidatesTags: (result) => [
        {
          type: 'Explanation' as const,
          id: result?.createFileExplanation.explanationId,
        },
      ],
    },
    CreateFileDifferencesExplanation: {
      invalidatesTags: (result) => [
        {
          type: 'Explanation' as const,
          id: result?.createFileDifferencesExplanation.explanationId,
        },
      ],
    },
    CreateChangeDocumentation: {
      invalidatesTags: (result) => [
        {
          type: 'Explanation' as const,
          id: result?.createChangeDocumentation.explanationId,
        },
      ],
    },
    CreateProjectDocumentation: {
      invalidatesTags: (result) => [
        {
          type: 'Explanation' as const,
          id: result?.createProjectDocumentation.explanationId,
        },
      ],
    },
    ReadAllChats: {
      providesTags: (_, __, ___) => [{ type: 'Chat' as const, id: 'LIST' }],
    },
    ReadChat: {
      providesTags: (_, __, arg) => [{ type: 'Chat' as const, id: arg.chatId }],
    },
    ReadChangeDocumentation: {
      providesTags: (_, __, arg) => [
        { type: 'Explanation' as const, id: arg.explanationId },
      ],
    },
    ReadProjectDocumentation: {
      providesTags: (_, __, arg) => [
        { type: 'Explanation' as const, id: arg.explanationId },
      ],
    },
    StartChat: {
      invalidatesTags: (result) => [
        {
          type: 'Chat' as const,
          id: result?.startChat.chatId,
        },
        {
          type: 'Chat' as const,
          id: 'LIST',
        },
      ],
    },
    ContinueChat: {
      invalidatesTags: (result) => [
        {
          type: 'Chat' as const,
          id: result?.continueChat.chatId,
        },
        {
          type: 'Chat' as const,
          id: 'LIST',
        },
      ],
    },
    ReadProjectAnalysis: {
      providesTags: (_, __, args) => [
        { type: 'Analysis' as const, id: args?.analysisId },
      ],
    },
    CreateProjectAnalysis: {
      invalidatesTags: (_, __, args) => [
        { type: 'Analysis' as const, id: args?.analysis?.analysisId },
      ],
    },
  },
});

export const {
  useCreateExplanationMutation,
  useReadExplanationQuery,
  useReadAllChatsQuery,
  useStartChatMutation,
  useReadChatQuery,
  useContinueChatMutation,
  useCreateChangeDocumentationMutation,
  useReadChangeDocumentationQuery,
  useReadFileExplanationQuery,
  useCreateFileExplanationMutation,
  useCreateFileDifferencesExplanationMutation,
  useCreateProjectDocumentationMutation,
  useReadProjectDocumentationQuery,
  useReadProjectAnalysisQuery,
  useCreateProjectAnalysisMutation,
  useCreateProjectAnalysisPresignedUrlMutation,
} = sdaiApi;
